import { render, staticRenderFns } from "./signatures-form.vue?vue&type=template&id=acd0c0e4&scoped=true"
import script from "./signatures-form.vue?vue&type=script&lang=js"
export * from "./signatures-form.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd0c0e4",
  null
  
)

export default component.exports